export default {
  biNotebookNotesByTag: 'BI_NOTEBOOK_NOTES_BY_TAG',
  biNotebookNotesByDateAndTag: 'BI_NOTEBOOK_NOTES_BY_DATE_AND_TAG',
  biNotebookNotesByDate: 'BI_NOTEBOOK_NOTES_BY_DATE',
  setLoadingState: 'BI_NOTEBOOK_NOTES_SET_LOADING_STATE',
};
